export const ZZZDriveSetsJSON = [
  {
    name: 'Astral Voice',
    piece_2: 'ATK +<b>10%</b>.',
    piece_4:
      'Whenever any squad member enters the field using a Quick Assist, all squad members gain <b>1</b> stack of Astral, up to a maximum of <b>3</b> stacks, and lasting <b>15s</b>. Repeated triggers reset the duration. Each stack of Astral increases the DMG dealt by the character entering the field using a Quick Assist by <b>8%</b>. Only one of this effect can be active at a time in the same squad.'
  },
  {
    name: 'Branch & Blade Song',
    element: 'Ice',
    piece_2: 'CRIT DMG +<b>16%</b>.',
    piece_4:
      "When Anomaly Mastery exceeds or equals 115 points, the equipper's CRIT damage increases by <b>30%</b>. When any squad member applies <u>Freeze</u> or triggers the <u>Shatter</u> effect on an enemy, the equipper's CRIT Rate increases by <b>12%</b>, lasting <b>15s</b>."
  },
  {
    name: 'Woodpecker Electro',
    piece_2: 'CRIT Rate +<b>8%</b>.',
    piece_4:
      'Triggering a critical hit with a Basic Attack, Dodge Counter or EX Special Attack increases the equippers ATK by <b>9%</b> for <b>6s</b>. The buff duration for different skills are calculated separately.'
  },
  {
    name: 'Puffer Electro',
    piece_2: 'PEN Ratio +<b>8%</b>.',
    piece_4:
      'Ultimate DMG increases by <b>20%</b>. Launching an Ultimate increases the equippers ATK by <b>15%</b> for <b>12s</b>.'
  },
  {
    name: 'Shockstar Disco',
    piece_2: 'Impact +<b>6%</b>.',
    piece_4:
      'Basic Attacks, Dash Attacks, and Dodge Counters, inflict <b>20%</b> more <b>Daze</b> upon the main target.'
  },
  {
    name: 'Freedom Blues',
    piece_2: 'Anomaly Proficiency +<b>30</b>.',
    piece_4:
      'When an EX Special Attack hits an enemy, reduce the targets Anomaly Buildup RES to equippers attribute by <b>20%</b> for <b>8s</b>. This effect does not stack with others of the same attribute.'
  },
  {
    name: 'Hormone Punk',
    piece_2: 'ATK +<b>10%</b>.',
    piece_4:
      "Upon entering combat or switching in, its user's ATK increased by <b>25%</b> for <b>10s</b>. This effect can be triggered once every <b>20s</b>."
  },
  {
    name: 'Soul Rock',
    piece_2: 'DEF +<b>16%</b>.',
    piece_4:
      'Upon receiving an enemy attack and losing HP, the equipper takes <b>40%</b> less DMG for <b>2.5s</b>. This effect can trigger once every <b>15s</b>.'
  },
  {
    name: 'Inferno Metal',
    element: 'Fire',
    piece_2: '<u>Fire DMG</u> +<b>10%</b>.',
    piece_4:
      "Upon hitting a <u>Burning</u> enemy, the equipper's CRIT Rate is increased by <b>28%</b> for <b>8s</b>."
  },
  {
    name: 'Chaotic Metal',
    element: 'Ether',
    piece_2: '<u>Ether DMG</u> +<b>10%</b>.',
    piece_4:
      "The equipper's CRIT DMG increases by <b>20%</b>. When any character in the squad triggers <u>Corruption's</u> additional DMG, this effect further increases by <b>5.5%</b> for <b>8s</b>, stacking up to <b>6</b> times. Repeated triggers reset the duration."
  },
  {
    name: 'Thunder Metal',
    element: 'Electric',
    piece_2: '<u>Electric DMG</u> +<b>10%</b>.',
    piece_4:
      "As long as an enemy in combat is <u>Shocked</u>, the equipper's ATK is increased by <b>28%</b>."
  },
  {
    name: 'Polar Metal',
    element: 'Ice',
    piece_2: '<u>Ice DMG</u> +<b>10%</b>.',
    piece_4:
      'Increases the DMG of Basic Attack and Dash Attack by <b>20%</b>. When any squad member inflicts <u>Freeze</u> or <u>Shatter</u>, this effect increases by an additional <b>20%</b> for <b>12s</b>.'
  },
  {
    name: 'Fanged Metal',
    element: 'Physical',
    piece_2: '<u>Physical DMG</u> +<b>10%</b>.',
    piece_4:
      'Whenever a squad member inflicts <u>Assault</u> on an enemy, the equipper deals <b>35%</b> increased damage to the target for <b>12s</b>.'
  },
  {
    name: 'Swing Jazz',
    element: 'Physical',
    piece_2: 'Energy Regen +<b>20%</b>.',
    piece_4:
      "Launching a Chain Attack or Ultimate increases all squad members' DMG by <b>15%</b> for <b>12s</b>. Passive effects of the same name do not stack."
  },
  {
    name: 'Proto Punk',
    piece_2: 'Shield Effect +<b>15%</b>.',
    piece_4:
      'When any squad member triggers a Defensive Assist or Evasive Assist, all squad members deal <b>15%</b> increased DMG, lasting <b>10s</b>. Passive effects of the same name do not stack.'
  },
  {
    name: 'Chaos Jazz',
    piece_2: 'Anomaly Proficiency +<b>30</b>.',
    piece_4:
      '<strong class="Fire">Fire DMG</strong> and <strong class="Electric">Electric DMG</strong> are increased by <b>15%</b>. When off-field, the damage caused by EX Special Attacks and Assist Attacks is increased by <b>20%</b>. When the character switches back onto the field, this buff continues for <b>5s</b>. The lasting effect can be triggered once every <b>7.5s</b>.'
  },
  {
    name: 'Shadow Harmony',
    piece_2:
      'The DMG of Aftershocks and Dash Attacks is increased by <b>15%</b>.',
    piece_4:
      "Upon hitting an enemy with an Aftershock or Dash Attack, if the DMG dealt aligns with the equipper's attribute, the equipper gains <b>1</b> stack of a buff effect, at most once per use of a skill. For each stack, the equipper's ATK increases by <b>4%</b>, and CRIT Rate increases by <b>4%</b>. The effect can stack up to <b>3</b> times and lasts for <b>15s</b>. Repeated triggers reset the duration."
  },
  {
    name: "Phaethon's Melody",
    piece_2: 'Anomaly Mastery +<b>8%</b>.',
    piece_4:
      'When any squad member uses an EX Special Attack, the equipper\'s Anomaly Proficiency increases by <b>45</b> for <b>8s</b>. If the character using the EX Special Attack is not the equipper, the equipper\'s <strong class="Ether">Ether DMG</strong> is increased by <b>25%</b>.'
  }
];
